import React from "react";
import getGoogleMapsLink from "./../../utilities/maps";
export const linkToGoogleMaps = (tableInfo, event) => {
  if (tableInfo && tableInfo.column) {
    let codigoErrorUbicacion;
    switch (tableInfo.column.id) {
      case "Mapa":
        codigoErrorUbicacion = tableInfo.original;
        window.open(
          getGoogleMapsLink(
            codigoErrorUbicacion.Latitud,
            codigoErrorUbicacion.Longitud,
            "_blank"
          )
        );
        break;
      default:
        break;
    }
  }
};

export const buildErrorCodesColumns = lang => {
  //sortableColumns = [Unidad, Fecha, Codigo, Descripcion, Ubicacion];
  const errorCodesColumns = [
    {
      Header: lang.Unidad,
      accessor: "Unidad"
    },
    {
      Header: lang.Fecha,
      accessor: "Fecha"
    },
    {
      Header: lang.Codigo,
      accessor: "Codigo"
    },
    {
      Header: lang.Descripcion,
      accessor: "Descripcion"
    },
    {
      Header: lang.Mapa,
      accessor: "Mapa",
      Cell: props => (
        <span className="link" onClick={linkToGoogleMaps.bind(null, props)}>
          {props.value}
        </span>
      )
    }
  ];

  return errorCodesColumns;
};



// WEBPACK FOOTER //
// ./src/containers/Scan/builders.js